import { render, staticRenderFns } from "./attribute_mapping.vue?vue&type=template&id=212f331e&"
import script from "./attribute_mapping.vue?vue&type=script&lang=js&"
export * from "./attribute_mapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports